import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { MenuIcon } from '../../common/icons';

const styles = require('./ordered-item.css');

/** Props for the check item */
export interface OrderedItemProps {
  /** Additional classes */
  className?: string;
  /** Label to show */
  label: string;
  /** Hint text for the question */
  hintText?: string;
  /** Whether it is selected */
  isDragging: boolean;
  /** Outlined */
  outlined?: boolean;
}

/**
 * A Check box and  a label.
 */
@observer
export class OrderedItem extends React.Component<OrderedItemProps> {
  /** Renders the component */
  render() {
    return (
      <div
        className={classnames(
          styles.orderedItem,
          this.props.outlined ? styles.outlined : undefined,
          this.props.isDragging ? styles.isDragging : undefined,
          this.props.className
        )}
      >
        <MenuIcon size="xsmall" color={this.props.outlined ? 'black' : undefined} />

        <div className={styles.orderedItemLabel}>
          <div>{this.props.label}</div>
          {this.props.hintText && <div className={styles.hintText}>{this.props.hintText}</div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/ordered-item/ordered-item.tsx